module.exports = __webpack_public_path__ + "img/ic-arrow-calendar.a81cfe43.svg";